export function toggleFormMobileAnimation(hidden) {
    const emailModal = document.getElementById('form-modal-email'),
        phoneModal = document.getElementById('form-modal-phone');

    if (hidden) {
        if (window.innerWidth >= 905) {
            emailModal.closest('label').classList.remove('selectmenu-open');
            phoneModal.closest('label').classList.remove('selectmenu-open');
        }
    } else {
        if (window.innerWidth >= 905) {
            emailModal.closest('label').classList.toggle('selectmenu-open');
            phoneModal.closest('label').classList.toggle('selectmenu-open');
        }
    }
}
